// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"6b3d160c","281":"c3fc77e5","403":"f764a30a","508":"f8889482","530":"4dcdbdc3","638":"78b942dc","706":"d0baf485","719":"295a754b","782":"aced68ff","787":"169a2284","959":"b9a0c8a0","994":"7b9d6416"}[chunkId] + ".chunk.js";
};